<ef-expense-receipt-view-presenter
    [attachment]="attachment$ | async"
></ef-expense-receipt-view-presenter>
